import React from 'react';
import { Button, Modal, ModalProps, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { isNull, isUndefined, map } from 'lodash';
import { useSelector } from 'react-redux';

import { Loading, LoadingError, RowItem, RowItemProps } from '@components/Base';
import { formatDateTime } from '@utils/datetime';
import { amountToUsd, formatPercentage } from '@utils/currency';
import { dUserName } from '@models/User';

import { selectFeaturePolicyCommissionInvoice } from './selector';

const ROW_ITEM_PROPS: RowItemProps = {
  className: 'mb-2',
  labelProps: { xs: 6, sm: 6, md: 5 },
};

const Content = () => {
  const { t } = useTranslation();
  const { invoice } = useSelector(selectFeaturePolicyCommissionInvoice);

  if (isUndefined(invoice)) return <Loading />;
  if (isNull(invoice)) return <LoadingError />;

  const {
    createdAt,
    cashFlow,
    paymentStatus,
    totalPremium,
    insurerCommissionPercentage,
    insurerCommissionAmount,
    mgaCommissionPercentage,
    mgaCommissionAmount,
    totalFrontlineCommissionPercentage,
    totalFrontlineCommissionAmount,
    frontlineCommissions,
  } = invoice;

  return (
    <>
      <RowItem {...ROW_ITEM_PROPS} label={t('common:createdDate')} value={formatDateTime(createdAt)} />
      <RowItem {...ROW_ITEM_PROPS} label="Cash flow" value={cashFlow} />
      <RowItem {...ROW_ITEM_PROPS} label="Payment status" value={paymentStatus} />
      <RowItem {...ROW_ITEM_PROPS} label="Total premium" value={amountToUsd(totalPremium)} />
      <RowItem {...ROW_ITEM_PROPS} label="Insurer commission percentage" value={formatPercentage(insurerCommissionPercentage)} />
      <RowItem {...ROW_ITEM_PROPS} label="Insurer commission amount" value={amountToUsd(insurerCommissionAmount)} />
      <RowItem {...ROW_ITEM_PROPS} label="MGA commission percentage" value={formatPercentage(mgaCommissionPercentage)} />
      <RowItem {...ROW_ITEM_PROPS} label="MGA commission amount" value={amountToUsd(mgaCommissionAmount)} />
      <RowItem {...ROW_ITEM_PROPS} label="Total frontline commission percentage" value={formatPercentage(totalFrontlineCommissionPercentage)} />
      <RowItem {...ROW_ITEM_PROPS} label="Total frontline commission amount" value={amountToUsd(totalFrontlineCommissionAmount)} />
      <Table>
        <thead>
          <tr>
            <th scope="col">Frontline</th>
            <th scope="col">Commission Percentage</th>
            <th scope="col">Commission Amount</th>
          </tr>
        </thead>
        <tbody>
          {map(frontlineCommissions, ({ id, frontline, commissionPercentage, commissionAmount }) => (
            <tr key={id}>
              <td>{dUserName(frontline)}</td>
              <td>{formatPercentage(commissionPercentage)}</td>
              <td>{amountToUsd(commissionAmount)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  )
}


const PolicyCommissionInvoiceDetailsModal = ({ invoice, ...props }: ModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Content />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          {t('common:close')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

export { PolicyCommissionInvoiceDetailsModal };
